export default __webpack_public_path__ + "static/media/standard-logo.ff74ea45.svg";